import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuthRequest } from "request/request";

export const findStaffs = createAsyncThunk(
  "director/findStaffs",
  async (search, { rejectWithValue }) => {
    try {
      let url = `staff/v1/find-staff`;

      if (search) {
        url += `?full_name=${search}`;
      }

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const findStudents = createAsyncThunk(
  "director/findStudents",
  async (search, { rejectWithValue }) => {
    try {
      let url = `student/v1/find-student`;

      if (search) {
        url += `?full_name=${search}`;
      }

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllSubjects = createAsyncThunk(
  "director/getAllSubjects",
  async (_, { rejectWithValue }) => {
    try {
      let url = `education/v1/all-subjects`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCollegeSchedule = createAsyncThunk(
  "director/getCollegeSchedule",
  async ({ student_type_id, start_date, end_date }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/college-schedule?student_type_id=${student_type_id}&start_date=${start_date}&end_date=${end_date}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJoutnalNotes = createAsyncThunk(
  "director/getJoutnalNotes",
  async (curriculum_id, { rejectWithValue }) => {
    try {
      let url = `education/v1/journal-note?curriculum_id=${curriculum_id}`;

      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendJoutnalNotes = createAsyncThunk(
  "director/sendJoutnalNotes",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      let url = `education/v1/journal-note`;

      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        dispatch(getJoutnalNotes(body?.curriculum_id));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStaffsControl = createAsyncThunk(
  "admin/getStaffsControl",
  async ({ date, staff_id }, { rejectWithValue }) => {
    try {
      let url = `staff/v1/staff-control?date=${date}`;

      if (staff_id) {
        url += `&staff_id=${staff_id}`;
      }
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
